import t from 'react-translate';
import LikertScale from 'shared/components/likert-scale';
import { primary } from 'styles/global_defaults/colors';
import { useState } from 'react';
import { scaleLimits } from '../constants';
import { QuestionProps } from './types';

const LikertScaleQuestion = ({
  questionId,
  questionIndex,
  questionText,
  showDivider = false,
  onResponse,
  dataQA,
  dataQAId,
}: QuestionProps) => {
  const [value, setValue] = useState<number>();
  const translationBase = t.MENTORING_PROGRAMS.PARTICIPANT_HOME.SESSION_PULSE_CHECK.FORM;

  const scaleLabelClassName = 'question-scale-label semi-bold text-regular text-nowrap';

  return (
    <div
      className={`likert-question ${showDivider ? 'divider' : ''}`}
      data-qa={dataQA}
      data-qa-id={dataQAId}
      aria-label={translationBase.ARIA_LABEL.LIKERT_SCALE_QUESTION(`${scaleLimits.max.value}`, `${scaleLimits.min.value}`, questionText)}
    >
      <div className='question-title semi-bold text-large-body mb-4'>
        {questionText}
        <span className='label text-danger'>*</span>
      </div>
      <div className='d-flex'>
        <span className={scaleLabelClassName}>
          {translationBase.PULSE_CHECK_SCALE_LABELS.DISAGREE()}
        </span>
        <div className='w-100'>
          <LikertScale
            value={value}
            limits={scaleLimits}
            onSelectValue={(selectedValue) => {
              const response = selectedValue as number;
              onResponse(questionIndex, questionId, response);
              setValue(response);
            }}
            showHandleColor={!!value}
            handleColor={primary}
          />
        </div>
        <span className={scaleLabelClassName}>
          {translationBase.PULSE_CHECK_SCALE_LABELS.AGREE()}
        </span>
      </div>
    </div>
  );
};

export default LikertScaleQuestion;
